<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('Safes')"
          :description="$t('Safes description')"
          :explanationPath="path + '/explaination'"
        />
        <indexTable
          :searchText="$t('Search for a safe')"
          :emptyTableText="$t('There are no safes')"
          :buttonRole="$checkRole('safes_add')"
          :localData="true"
          :filter="{ bank_account: 0 }"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :cloumns="[
            { column: 'id', title: $t('Code'), type: 'mainLink', sort: true },
            {
              column: 'name',
              title: $t('Customer name'),
              type: 'mainLink',
              sort: true
            },
            {
              column: 'balance',
              title: $t('Balance'),
              type: 'text',
              sort: true,
              icon: 'usd-square'
            },
            {
              column: 'stat',
              title: $t('Active'),
              type: 'stat',
              sort: true,
              hideMobile: true
            },
            {
              column: 'options',
              title: $t('Actions'),
              type: 'options',
              options: [
                { name: 'show' },
                {
                  name: 'edit',
                  role: $checkRole('safes_edit')
                },
                {
                  name: 'link',
                  role: $checkRole('safes_transfers_add'),

                  title: $t('Transfer from the treasury'),
                  icon: 'suitcase',
                  link: '/safesTransfers/create?from_safe_id='
                },
                {
                  name: 'link',
                  role: $checkRole('safes_deposits_add'),
                  title: $t('Deposit to the safe'),
                  icon: 'donate',
                  link: '/safesDeposits/create?safe_id='
                },
                {
                  name: 'link',
                  role: $checkRole('safes_withdrawals_add'),
                  title: $t('Withdrawal from the treasury'),
                  icon: 'money-bill-alt',
                  link: '/safesWithdrawals/create?safe_id='
                },
                {
                  name: 'delete',
                  role: $checkRole('safes_delete')
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'

import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'

export default {
  data() {
    return {
      path: '/safes'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
